import { useNuxtApp } from "nuxt/app";

export const useFeatureFlag = () => {
  return useNuxtApp().$featureFlag;
};
